import { taggedTemplateLiteral as _taggedTemplateLiteral, extends as _extends, objectWithoutProperties as _objectWithoutProperties } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import propTypes from '../../../node_modules/prop-types/index.js';
import React, { useCallback } from 'react';
import classnames from '../../../node_modules/classnames/index.js';
import { styled, useThemeProps, Rating as Rating$2 } from '@mui/material';
import Field from '../Field.js';
import connectForm$1 from '../../../cinnamon-core/es/components/forms/connectForm.js';
import { createComponentSlot } from '../../../modules/styling/theme.js';
import { prettifyField, filterProps, fieldErrors } from '../../../cinnamon-core/es/components/forms/utils.js';
import { requiredField } from '../../../cinnamon-core/es/components/forms/validators/requiredField.js';

var _templateObject;

var _excluded = ["value", "onChange", "errors", "showErrors", "allErrors", "animateErrors", "disabled", "readOnly", "renderReadOnly", "label", "labelProps", "width", "fluid", "required", "passThruProps", "forwardedRef", "className", "sx", "variant"];
var componentRoot = createComponentSlot({
  name: "CinFormRating",
  slot: "Root"
});

var RatingBase = function RatingBase(props) {
  var _props$value = props.value,
      value = _props$value === void 0 ? null : _props$value,
      onChange = props.onChange,
      errors = props.errors,
      showErrors = props.showErrors,
      allErrors = props.allErrors,
      animateErrors = props.animateErrors,
      disabled = props.disabled,
      readOnly = props.readOnly,
      renderReadOnly = props.renderReadOnly,
      label = props.label,
      labelProps = props.labelProps,
      width = props.width,
      fluid = props.fluid,
      required = props.required,
      passThruProps = props.passThruProps,
      forwardedRef = props.forwardedRef,
      className = props.className;
      props.sx;
      props.variant;
      var otherProps = _objectWithoutProperties(props, _excluded);

  var onRatingChange = useCallback(function (e, v) {
    if (readOnly || !onChange) return;
    onChange(v);
  }, [onChange]);
  var muiProps = filterProps(passThruProps, Object.keys(otherProps));
  return /*#__PURE__*/React.createElement(Field, {
    required: required,
    disabled: disabled,
    renderReadOnly: readOnly && renderReadOnly ? function () {
      return renderReadOnly(props);
    } : false,
    width: width !== null && width !== void 0 ? width : null,
    fluid: fluid,
    label: label,
    labelProps: labelProps,
    errors: fieldErrors(errors, showErrors, allErrors),
    animateErrors: animateErrors,
    className: classnames(componentRoot.className, className),
    ref: forwardedRef
  }, /*#__PURE__*/React.createElement(Rating$2, _extends({}, muiProps, {
    value: value,
    onChange: onRatingChange,
    readOnly: readOnly,
    disabled: disabled
  })));
};

RatingBase.propTypes = {
  label: propTypes.node,
  labelProps: propTypes.any,
  width: propTypes.oneOfType([propTypes.number, propTypes.string]),
  fluid: propTypes.bool,
  renderReadOnly: propTypes.func,
  className: propTypes.string,
  sx: propTypes.any,
  variant: propTypes.any
};
var ConnectedRating = connectForm$1({
  displayName: function displayName(props) {
    return props.label && typeof props.label === "string" ? props.label : prettifyField(props.field);
  },
  validators: [requiredField(false)]
})(RatingBase);
var RatingRoot = styled(ConnectedRating, componentRoot.styledOptions)(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));
/**
 * Field for choosing a rating value
 */

var Rating = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var rootProps = useThemeProps({
    props: props,
    name: componentRoot.name
  });
  return /*#__PURE__*/React.createElement(RatingRoot, _extends({}, rootProps, {
    ref: ref
  }));
});
var Rating$1 = Rating;

export { Rating$1 as default };
